import React from 'react';

import AutoComplete from 'components/AppointmentInfoCard/Service/AutoComplete';

import css from './PractitionerDropdownSection.module.scss';
import { Specialty } from 'interfaces/specialty';

interface Props {
  isOpen: boolean;
  options: {
    id: string;
    title: string;
    avatar: string;
    rating: number;
    reviewCount: number;
    specialties: Specialty[];
  }[];
  optionValue: { id: string; title: string };
  onChangeIsOpen: (isOpen: boolean) => void;
  onChangePractitionerOption: (option: {
    id: string;
    title: string;
    duration: number;
  }) => void;
  defaultOption: { id: string; title: string };
  isPopperFullWidth?: boolean;
}

const ReasonSection: React.FC<Props> = ({
  isOpen,
  options,
  optionValue,
  defaultOption,
  onChangeIsOpen,
  onChangePractitionerOption,
  isPopperFullWidth = false,
}) => {
  return (
    <div className={css['container']}>
      <h4 className={css['title']}>Practitioner</h4>
      <AutoComplete
        isOpen={isOpen}
        options={options}
        optionValue={optionValue}
        onChangeIsOpen={onChangeIsOpen}
        onChangeServiceOption={onChangePractitionerOption}
        defaultOption={defaultOption}
        height="2.1rem"
        isPractitionerDropdown
        isPopperFullWidth={isPopperFullWidth}
      />
    </div>
  );
};

export default ReasonSection;
